class ValidatorRegistry {

    constructor() {
        this._validators = []
    }

    addValidator(Validator) {

        if (this._validators.some((validator) => validator.name === Validator.name)) {
            console.warn(`Validator ${Validator.name} is already registered`)
            return
        }

        this._validators.push(Validator)
    }

    getValidators() {
        return this._validators
    }

}

export {ValidatorRegistry}
